<template>
    <div class="container-fluid">
        <Toastselectedlet :bus="toast"></Toastselectedlet>
        <div class="row mt-5">
            <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                  <div class="row">
                <div class="col-md-0.5">
                        <input type="checkbox" v-model="CheckEmployee" />
                </div>
                <div class="col-md-3">
                    <div class="form-group">

                        <multiselect
                            v-model="GlobalEmployee"
                            :options="employee_master"
                            :allow-empty="false"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            :custom-label="customLabel"
                            track-by="EMPLOYEE_ID"
                            :close-on-select="true"
                            @input="changeInEmployee"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>

              </div>
            </div>
            </div>
            </div>
        </div>
            <!-- /.row -->
            <div class="col-md-12">
                <div class="card">
                <div class="card-header">
                    <h3 class="card-title">Allocation List</h3>

                    <div class="card-tools">
                        <button v-if="!allocationButtonStatus" class="btn btn-success" @click="AllocatDataCheck()">Do Allocate</button>
                        <div v-if="allocationButtonStatus" class="spinner-grow text-success" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <!-- /.card-header -->
                    <!-- /.card-header -->
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>Login Id</th>
                            <th>Applicant Name</th>
                            <th>Residential Address</th>
                            <th>Contact Person Mobile Number</th>
                            <th>Office Address</th>
                            <th>Office Mobile Number</th>
                            <th>Allocated Executive</th>
                        </tr>
                        <tr v-for="(client_master) in selectedData" :key="client_master.CLIENT_ID">
                            <td> {{ client_master.Login_Id}} </td>
                            <td> {{ client_master.Applicant_Name}} </td>
                            <td> {{ client_master.Residential_Address}} </td>
                            <td> {{ client_master.Contact_Person_Mobile_Number}} </td>
                            <td> {{ client_master.Office_Address}} </td>
                            <td> {{ client_master.Office_Mobile_Number}} </td>
                            <td>
                                <multiselect
                                    v-model="client_master.EMPLOYEE_SELECT"
                                    :options="employee_master"
                                    :allow-empty="false"
                                    open-direction="bottom"
                                    deselect-label="Can't remove this value"
                                    :custom-label="customLabel"
                                    track-by="EMPLOYEE_ID"
                                    :close-on-select="true"
                                    aria-required="true">
                                </multiselect></td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                </div>
            </div>
            <!-- /.row -->
        </div>
</template>

<script>
    import Toastselectedlet from "../widget/toast";
    import moment from 'moment'
    export default {
        components: { Multiselect,Toastselectedlet },
        data(){
            return{
                allocationButtonStatus:false,
                toast: new Vue(),
                selected: [],
                GlobalEmployee:'',
                employee_master:[],
                CheckEmployee:true,
                selectAll: false,
                selectedData: [],
            }
        },
        created() {
            if(this.$route.params.AllocationList == undefined || this.$route.params.AllocationList == null){
                this.$router.push({
                            name: "ViewClient"
                        });
            }
        },
        mounted(){
            this.loadEmployee()
            this.AssigntoEmployeeModel()
        },
        methods:{
            AllocatDataCheck(){
                this.allocationButtonStatus = true;
                axios.post('/ECV_Junction',this.selectedData)
                .then(()=> {
                    this.allocationButtonStatus = false;
                    this.toast.$emit('ToastSuccess',"Allocate SuccesFul");
                    this.$router.push({
                        name: "ViewClient"
                    });
                })
                .catch(() => {
                    this.allocationButtonStatus = false;
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            customLabel(option) {
                return `${option.Employee_First_Name} ${option.Employee_Last_Name}(${option.Employee_User_Id})`
            },
            loadEmployee(){
                axios.get('/loadEmployee')
                .then(({data})=> {this.employee_master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            changeInEmployee(){
                for(var i=0; i<this.selectedData.length;i++)
                {
                    this.selectedData[i].EMPLOYEE_SELECT = this.GlobalEmployee;
                }
            },
            AssigntoEmployeeModel() {
                this.selected= this.$route.params.AllocationList
                for(var i=0;i<this.selected.length;i++){
                    if(this.selected[i].Residential_Address != null && this.selected[i].Office_Address != null){
                        this.selectedData.push({
                            "Location_Type":"RV",
                            "CLIENT_ID":this.selected[i].CLIENT_ID,
                            "Login_Id":this.selected[i].Login_Id,
                            "Bank_Name":this.selected[i].Bank_Name,
                            "PRODUCT_ID_REF":this.selected[i].PRODUCT_ID_REF,
                            "Applicant_Name":this.selected[i].Applicant_Name,
                            "Residential_Address":this.selected[i].Residential_Address,
                            "Contact_Person_Mobile_Number":this.selected[i].Contact_Person_Mobile_Number,
                            "Office_Address":null,
                            "Office_Mobile_Number":null,
                            "Loan_Amount":this.selected[i].Loan_Amount,
                            "Client_Is_Active":this.selected[i].Client_Is_Active,
                            "Product_Name":this.selected[i].Product_Name,
                            "EMPLOYEE_SELECT":null,
                            "time":null
                        })
                        this.selectedData.push({
                            "Location_Type":"BV",
                            "CLIENT_ID":this.selected[i].CLIENT_ID,
                            "Login_Id":this.selected[i].Login_Id,
                            "Bank_Name":this.selected[i].Bank_Name,
                            "PRODUCT_ID_REF":this.selected[i].PRODUCT_ID_REF,
                            "Applicant_Name":this.selected[i].Applicant_Name,
                            "Residential_Address":null,
                            "Contact_Person_Mobile_Number":null,
                            "Office_Address":this.selected[i].Office_Address,
                            "Office_Mobile_Number":this.selected[i].Office_Mobile_Number,
                            "Loan_Amount":this.selected[i].Loan_Amount,
                            "Client_Is_Active":this.selected[i].Client_Is_Active,
                            "Product_Name":this.selected[i].Product_Name,
                            "EMPLOYEE_SELECT":null,
                            "time":null
                        })
                    } else if(this.selected[i].Residential_Address != null) {
                        this.selectedData.push({
                            "Location_Type":"RV",
                            "CLIENT_ID":this.selected[i].CLIENT_ID,
                            "Login_Id":this.selected[i].Login_Id,
                            "Bank_Name":this.selected[i].Bank_Name,
                            "PRODUCT_ID_REF":this.selected[i].PRODUCT_ID_REF,
                            "Applicant_Name":this.selected[i].Applicant_Name,
                            "Residential_Address":this.selected[i].Residential_Address,
                            "Contact_Person_Mobile_Number":this.selected[i].Contact_Person_Mobile_Number,
                            "Office_Address":this.selected[i].Office_Address,
                            "Office_Mobile_Number":this.selected[i].Office_Mobile_Number,
                            "Loan_Amount":this.selected[i].Loan_Amount,
                            "Client_Is_Active":this.selected[i].Client_Is_Active,
                            "Product_Name":this.selected[i].Product_Name,
                            "EMPLOYEE_SELECT":null,
                            "time":null
                        })
                    }  else if(this.selected[i].Office_Address != null) {
                        this.selectedData.push({
                            "Location_Type":"BV",
                            "CLIENT_ID":this.selected[i].CLIENT_ID,
                            "Login_Id":this.selected[i].Login_Id,
                            "Bank_Name":this.selected[i].Bank_Name,
                            "PRODUCT_ID_REF":this.selected[i].PRODUCT_ID_REF,
                            "Applicant_Name":this.selected[i].Applicant_Name,
                            "Residential_Address":this.selected[i].Residential_Address,
                            "Contact_Person_Mobile_Number":this.selected[i].Contact_Person_Mobile_Number,
                            "Office_Address":this.selected[i].Office_Address,
                            "Office_Mobile_Number":this.selected[i].Office_Mobile_Number,
                            "Loan_Amount":this.selected[i].Loan_Amount,
                            "Client_Is_Active":this.selected[i].Client_Is_Active,
                            "Product_Name":this.selected[i].Product_Name,
                            "EMPLOYEE_SELECT":null,
                            "time":null
                        })
                    }
                }
            }
        }
    }
</script>
